import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import classNames from 'classnames';
import styles from './grid.css';
/**
 * @name Grid
 */
export class Grid extends Component {
    render() {
        const { children, className, ...restProps } = this.props;
        const classes = classNames(styles['container-fluid'], className);
        return (_jsx("div", { "data-test": "ring-grid", ...restProps, className: classes, children: children }));
    }
}
export { default as Row } from './row';
export { default as Col } from './col';
